import { useId } from 'react';
import { SelectableValue, TabsProps } from './tabs/types';
import { getActiveIndex } from './tabs/navigation';
import { TabList } from './tabs/TabList';
export { TabNavigation } from './tabs/TabNavigation';
export { SegmentedControl } from './tabs/SegmentedControl';
export type { TabItem } from './tabs/types';

export function Tabs<Value extends SelectableValue>({ ariaLabel, className, items, keepMounted = false, onChange, value }: TabsProps<Value>) {
  const generatedId = useId();
  const activeIndex = getActiveIndex(items, value);
  const activeItem = items[activeIndex];

  if (activeItem === undefined) {
    return null;
  }

  return (
    <div className={['ui-tabs', className].filter(Boolean).join(' ')}>
      <TabList ariaLabel={ariaLabel} generatedId={generatedId} items={items} onChange={onChange} value={value} />
      {items.map((item, index) => (keepMounted || index === activeIndex) ? (
        <div aria-labelledby={`${generatedId}-tab-${index}`} className="ui-tabs__panel" hidden={index !== activeIndex} id={`${generatedId}-panel-${index}`} key={item.value} role="tabpanel" tabIndex={0}>
          {item.content}
        </div>
      ) : null)}
    </div>
  );
}
